    import { Menu, MenuItem, Icon } from 'semantic-ui-react';
import { useEffect, useState } from 'react';
import { IndividualReadinessReport } from './IndividualReadinessReport';

export const ReadinessMenu = (props) => {
    const [type, setChosenElement] = useState(props.type ? props.type : "team")

    useEffect(() => {
        window.history.replaceState(null, "", type.toLowerCase())
    }, [type])

    return (
        <>
            <div align="center" style={{ paddingBottom: "2rem" }}>
                <div style={{ width: "fit-content" }}>
                    <Menu pointing>
                        <MenuItem content={<><Icon color="grey" className="users" />Teams</>} name="team" onClick={() => setChosenElement('team')} active={type === 'team'} />
                        <MenuItem content={<><Icon color="grey" className="truck" />Assets</>} name="asset" onClick={() => setChosenElement('asset')} active={type === 'asset'} />
                        <MenuItem
                            content={<><Icon color="grey" className="user" />Members</>}
                            name="member"
                            onClick={() => setChosenElement('member')}
                            active={type === 'member'} />
                    </Menu>
                </div>
            </div>
            <IndividualReadinessReport type={type} />
        </>
    );

}
